export default {"src":"/_next/static/media/air-conditioner.ffdaeff0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};